import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        workshopsLocales: undefined,
        placeCode: undefined,
        placeContext: undefined,
        userToken: undefined,
        user: undefined,
        userWorkshops: []
    },
    mutations: {
        setWorkshopsLocales(state, workshopsLocales) {
            state.workshopsLocales = workshopsLocales
        },
        setPlaceCode(state, placeCode) {
            state.placeCode = placeCode
        },
        resetPlaceCode(state) {
            state.placeCode = undefined
        },
        setPlaceContext(state, placeContext) {
            state.placeContext = placeContext
        },
        setUserToken(state, userToken) {
            state.userToken = userToken
        },
        setUser(state, user) {
            state.user = user
        },
        setUserWorkshops(state, userWorkshops) {
            state.userWorkshops = userWorkshops
        },
        addUserWorkshop(state, workshop) {
            state.userWorkshops.push(workshop)
        },
        removeUserWorkshop(state, workshopToRemove) {
            let workshopIndex = state.userWorkshops.findIndex(workshop => workshop.uuid == workshopToRemove.uuid)
            state.userWorkshops.splice(workshopIndex, 1)
        },
    },
    actions: {
        setWorkshopsLocales(context, workshopsLocales) {
            context.commit('setWorkshopsLocales', workshopsLocales)
        },
        setPlaceCode(context, placeCode) {
            context.commit('setPlaceCode', placeCode)
        },
        resetPlaceCode(context) {
            context.commit('resetPlaceCode')
        },
        setPlaceContext(context, placeContext) {
            context.commit('setPlaceContext', placeContext)
        },
        setUserToken(context, userToken) {
            context.commit('setUserToken', userToken)
        },
        setUser(context, user) {
            context.commit('setUser', user)
        },
        setUserWorkshops(context, userWorkshops) {
            context.commit('setUserWorkshops', userWorkshops)
        },
        addUserWorkshop(context, workshop) {
            context.commit('addUserWorkshop', workshop)
        },
        removeUserWorkshop(context, workshop) {
            context.commit('removeUserWorkshop', workshop)
        }
    }
})

export default store
